module.exports = [
    {
        "ident": "VGZR",
        "type": "large_airport",
        "name": "Hazrat Shahjalal International Airport",
        "elevation_ft": 30,
        "continent": "AS",
        "iso_country": "BD",
        "iso_region": "BD-3",
        "municipality": "Dhaka",
        "gps_code": "VGHS",
        "iata_code": "DAC",
        "local_code": "",
        "coordinates": "23.843347, 90.397783"
    },
    {
        "ident": "VGEG",
        "type": "medium_airport",
        "name": "Shah Amanat International Airport",
        "elevation_ft": 12,
        "continent": "AS",
        "iso_country": "BD",
        "iso_region": "BD-2",
        "municipality": "Chittagong",
        "gps_code": "VGEG",
        "iata_code": "CGP",
        "local_code": "",
        "coordinates": "22.24959945678711, 91.81330108642578"
    },
    {
        "ident": "VGCB",
        "type": "medium_airport",
        "name": "Cox's Bazar Airport",
        "elevation_ft": 12,
        "continent": "AS",
        "iso_country": "BD",
        "iso_region": "BD-2",
        "municipality": "Cox's Bazar",
        "gps_code": "VGCB",
        "iata_code": "CXB",
        "local_code": "",
        "coordinates": "21.452199935913086, 91.96389770507812"
    },
    {
        "ident": "VGRJ",
        "type": "medium_airport",
        "name": "Shah Mokhdum Airport",
        "elevation_ft": 64,
        "continent": "AS",
        "iso_country": "BD",
        "iso_region": "BD-5",
        "municipality": "Rajshahi",
        "gps_code": "VGRJ",
        "iata_code": "RJH",
        "local_code": "",
        "coordinates": "24.43720054626465, 88.61650085449219"
    },
    {
        "ident": "VGSD",
        "type": "medium_airport",
        "name": "Saidpur Airport",
        "elevation_ft": 125,
        "continent": "AS",
        "iso_country": "BD",
        "iso_region": "BD-5",
        "municipality": "Saidpur",
        "gps_code": "VGSD",
        "iata_code": "SPD",
        "local_code": "",
        "coordinates": "25.759199142456055, 88.90889739990234"
    },
    {
        "ident": "VGBR",
        "type": "medium_airport",
        "name": "Barisal Airport",
        "elevation_ft": 23,
        "continent": "AS",
        "iso_country": "BD",
        "iso_region": "BD-1",
        "municipality": "Barisal",
        "gps_code": "VGBR",
        "iata_code": "BZL",
        "local_code": "",
        "coordinates": "22.801000595092773, 90.30120086669922"
    },
    {
        "ident": "VGSY",
        "type": "medium_airport",
        "name": "Osmany International Airport",
        "elevation_ft": 50,
        "continent": "AS",
        "iso_country": "BD",
        "iso_region": "BD-6",
        "municipality": "Sylhet",
        "gps_code": "VGSY",
        "iata_code": "ZYL",
        "local_code": "",
        "coordinates": "24.963199615478516, 91.8667984008789"
    },

]